import { Routes } from '@angular/router';
import { calGuard } from '@cvx/cal-angular';
import { Error as ErrorPage } from './layouts/error/error';
import { Master } from './layouts/master/master';
import { APP_ROUTES } from './core/constants/app-navigation.constants';


export const routes: Routes = [
  {
    path: '',
    component: Master,
    canActivate: [calGuard],
    children: [
      /** Dashboard TAB */
      {
        path: '',
        loadComponent: () => import('./features/discover/discover').then((m) => m.Discover),
      },
      {
        path: APP_ROUTES.DASHBOARD,
        loadComponent: () => import('./features/dashboard/dashboard').then((m) => m.Dashboard),
      },

      /** Discover TAB */
      {
        path: APP_ROUTES.DISCOVER,
        loadComponent: () => import('./features/discover/discover').then((m) => m.Discover),
      },

      /** Evaluation TAB */
      {
        path: APP_ROUTES.EVALUATION,
        loadComponent: () =>
          import('./features/evaluations/evaluations').then((m) => m.Evaluations),
      },

      /** Operations Log TAB */
      {
        path: APP_ROUTES.OPERATION_LOG,
        loadComponent: () =>
          import('./features/operations-log/operations-log').then((m) => m.OperationsLog),
      },

      {
        path: 'clusters/:clusterId/comparison-matrices/:runId/report',
        loadComponent: () =>
          import('./features/matrix-report/matrix-report').then((m) => m.MatrixReport),
      },

      /** ERROR Page */
      {
        path: APP_ROUTES.ERROR,
        loadComponent: () => import('./layouts/error/error').then((c) => c.Error),
      },

      /** Unauthorized Page */
      {
        path: APP_ROUTES.UNAUTHORIZED,
        loadComponent: () =>
          import('./layouts/unauthorized/unauthorized').then((c) => c.Unauthorized),
      },

      /** DEFAULT */
      {
        path: '**',
        redirectTo: `${APP_ROUTES.DASHBOARD}`,
      },
      {
        path: '*',
        redirectTo: `${APP_ROUTES.DASHBOARD}`,
      },
    ],
  },
];
